// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2uz-K","title":"FrontImage_title__19tgt"};